import { styled } from "@mui/material/styles";

export const ContentContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  padding: "1rem",
  width: "100%",
}));

export const AccordionContainer = styled("div")(() => ({
  padding: "1rem 0",
  width: "100%",
}));

export const TextInputContainer = styled("div")(() => ({
  padding: "0 1rem 1rem 1rem",
}));

export const AccordionSpacing = styled("div")(() => ({
  padding: "0.5rem 0",
  width: "100%",
}));

export const ButtonContainers = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "1rem",
  padding: "1rem",
  alignItems: "center",
  justifyContent: "end",
}));

export const TemplateDescription = styled("div")(() => ({
  display: "block",
  width: "420px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const ADLSelectorsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between",
}));

export const DateSelectors = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "1.5rem",
}));

export const AssetDetails = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
}));

export const AssetReadingGeneratorSwitches = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
}));

export const AssetSwitchesContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignItems: "center",
}));

export const AssetAccordionDetails = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
}));
